export default {
  welcomeSlide0: require('APP/Theme/Videos/welcomeSlide0.mp4'),
}
